import {
  Component,
  ElementRef,
  AfterViewInit,
  Renderer2,
  Input,
  Inject,
  ViewChild,
  OnDestroy,
  EventEmitter,
  Output,
} from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { IconComponent } from '../../atoms/icon/icon.component';
import { Router, RouterModule } from '@angular/router';

import { Colors, Sizes } from '../../../shared/enums/shared.enums';
import { CaasBodytextService } from '../../../services/caas-bodytext.service';

@Component({
  selector: 'hdi-tooltip',
  standalone: true,
  imports: [CommonModule, IconComponent, RouterModule],
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class TooltipComponent implements AfterViewInit, OnDestroy {
  @Input() type: 'click' | 'hover' = 'click';
  @Output() closeTooltipEvent = new EventEmitter<void>();
  @ViewChild('tooltipContainer') tooltipContainer: ElementRef<HTMLElement> =
    {} as ElementRef<HTMLElement>;
  private _tooltip: { id: string; description: string } = {
    id: '',
    description: '',
  };
  @Input()
  set tooltip(value: { id: string; description: string }) {
    if (value) {
      this._tooltip = {
        ...value,
        description: this.caasBodytextService.extractTextEditorContent(
          value.description,
          'bodytext-link--white'
        ),
      };
    }
  }

  get tooltip(): { id: string; description: string } {
    return this._tooltip;
  }
  parentElement: ElementRef<HTMLElement> = {} as ElementRef<HTMLElement>;
  routerLinkEventListener?: EventListener;

  Sizes = Sizes;
  Colors = Colors;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly renderer: Renderer2,
    private readonly el: ElementRef,
    private readonly router: Router,
    private readonly caasBodytextService: CaasBodytextService
  ) {
    this.tooltip = {
      id: '',
      description: '',
    };
  }

  ngAfterViewInit(): void {
    this.parentElement = this.el.nativeElement.parentElement;
    this.renderer.setStyle(this.parentElement, 'position', 'relative');
    const routerLinkElement =
      this.tooltipContainer.nativeElement.querySelector('[routerLink]');
    if (routerLinkElement) {
      this.routerLinkEventListener = (event: Event) => {
        event.preventDefault();
        this.router.navigateByUrl(
          routerLinkElement.getAttribute('routerLink') || ''
        );
      };
      routerLinkElement.addEventListener('click', this.routerLinkEventListener);
    }
    this.tooltip.description =
      this.caasBodytextService.extractTextEditorContent(
        this.tooltip.description
      );
  }

  closeTooltip(event: Event) {
    event.stopPropagation();
    this.closeTooltipEvent.emit();
  }

  ngOnDestroy(): void {
    if (this.routerLinkEventListener) {
      this.tooltipContainer.nativeElement.removeEventListener(
        'click',
        this.routerLinkEventListener
      );
    }
  }
}
